import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../../ui/custom-table";
import { GetAttendenceApi } from "../../../api/api";

function AttendenceRecord() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format: "2025-06-25"
  });
  const fetchRecord = async (d) => {
    setLoading(true);
    try {
      const data = await GetAttendenceApi(d);
      if (data?.data?.status === true) {
        setRecords(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecord(selectedDate);
  }, [selectedDate]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "employee_image",
        header: "Employee Image",
        Cell: ({ row }) => {
          const imagePath = row.original.image_dataset_path;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },
      {
        accessorKey: "student_name",
        header: "Student Name",
      },
      {
        accessorKey: "operation",
        header: "Status",
      },

      {
        accessorKey: "created_at",
        header: "Time",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value
            ? new Date(value).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-";
        },
      },
    ],
    []
  );
  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">CheckIn/Checkout Record</h5>
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          className="form-control"
          style={{ maxWidth: "200px" }}
        />
      </div>

      <CustomTable
        columns={columns}
        data={records}
        loading={loading}
        addButtonLabel="Create New"
      />
    </>
  );
}

export default AttendenceRecord;
